module.exports = __webpack_public_path__ + "img/tg.b3fdb43c.svg";